/* MD Masala theme by Zoon Network · zoon.network */
(function () {
  'use strict';
  if (window.__mdco) return;
  window.__mdco = true;

  var EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
  function phoneOk(v) {
    var d = v.replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    else if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    return d.length === 10;
  }
  function shown(el) {
    var wrap = el.closest('.mdco-fo__fld') || el;
    return wrap.getClientRects().length > 0;
  }
  function check(el, msgs) {
    if (!shown(el)) return '';
    var v = (el.value || '').trim();
    var kind = el.getAttribute('data-mdco-field');
    if (!v) return el.required ? msgs.required : '';
    if (kind === 'tel' && !phoneOk(v)) return msgs.phone;
    if (kind === 'email' && !EMAIL.test(v)) return msgs.email;
    return '';
  }
  function show(el, text) {
    var msg = document.getElementById(el.id + '-m');
    var dd = el.closest('[data-mdco-dd]');
    if (msg) msg.textContent = text;
    if (text) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
    if (dd) {
      dd.classList.toggle('is-invalid', !!text);
      var b = dd.querySelector('.mdco-dd__btn');
      if (b) { if (text) b.setAttribute('aria-invalid', 'true'); else b.removeAttribute('aria-invalid'); }
    }
  }

  function initForm(form) {
    var box = form.closest('[data-mdco-msgs]');
    if (!box || form.__mdco) return;
    form.__mdco = true;
    var msgs = { required: box.getAttribute('data-mdco-required'), phone: box.getAttribute('data-mdco-phone'), email: box.getAttribute('data-mdco-email') };
    var sum = form.querySelector('[data-mdco-sum]');
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-mdco-field]'));
    var tried = false;
    fields.forEach(function (el) {
      var again = function () {
        if (tried || el.hasAttribute('aria-invalid')) show(el, check(el, msgs));
        if (sum && sum.textContent && !form.querySelector('[data-mdco-field][aria-invalid]')) sum.textContent = '';
      };
      el.addEventListener('input', again);
      el.addEventListener('change', again);
      el.addEventListener('blur', function () { if ((el.value || '').trim()) show(el, check(el, msgs)); });
    });
    form.addEventListener('submit', function (e) {
      tried = true;
      var first = null;
      fields.forEach(function (el) {
        var t = check(el, msgs);
        show(el, t);
        if (t && !first) first = el;
      });
      if (sum) sum.textContent = first ? box.getAttribute('data-mdco-check') || '' : '';
      if (first) {
        e.preventDefault();
        var dd = first.closest('[data-mdco-dd]');
        var target = dd && dd.classList.contains('is-ready') ? dd.querySelector('.mdco-dd__btn') : first;
        target.focus();
        if (target.scrollIntoView) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });
  }

  var openLists = [];
  document.addEventListener('click', function (e) {
    openLists.slice().forEach(function (x) { if (!x.dd.isConnected) { openLists.splice(openLists.indexOf(x), 1); return; } if (!x.dd.contains(e.target)) x.close(false); });
  });

  function initDropdown(dd) {
    if (dd.__mdco) return;
    dd.__mdco = true;
    var sel = dd.querySelector('select'), btn = dd.querySelector('.mdco-dd__btn'), list = dd.querySelector('.mdco-dd__list');
    var val = dd.querySelector('.mdco-dd__val');
    var opts = list ? Array.prototype.slice.call(list.querySelectorAll('[role="option"]')) : [];
    if (!sel || !btn || !opts.length) return;
    var hi = 0, empty = val.textContent;
    dd.classList.add('is-ready');
    btn.hidden = false;
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');
    function paint() {
      opts.forEach(function (o, k) { o.classList.toggle('is-hi', k === hi); });
      list.setAttribute('aria-activedescendant', opts[hi].id);
      var o = opts[hi];
      if (o.scrollIntoView) o.scrollIntoView({ block: 'nearest' });
    }
    var me = { dd: dd, close: close };
    function open() {
      list.hidden = false; btn.setAttribute('aria-expanded', 'true');
      if (openLists.indexOf(me) < 0) openLists.push(me);
      hi = Math.max(0, opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; }));
      paint(); list.focus();
    }
    function close(refocus) {
      list.hidden = true; btn.setAttribute('aria-expanded', 'false');
      var i = openLists.indexOf(me); if (i >= 0) openLists.splice(i, 1);
      if (refocus) btn.focus();
    }
    function sync() {
      var v = sel.value;
      opts.forEach(function (o) { o.setAttribute('aria-selected', o.getAttribute('data-value') === v ? 'true' : 'false'); });
      val.textContent = v || empty;
      val.classList.toggle('is-empty', !v);
    }
    function pick(k) {
      sel.value = opts[k].getAttribute('data-value');
      sync();
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      close(true);
    }
    btn.addEventListener('click', function () { if (list.hidden) open(); else close(true); });
    btn.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && list.hidden) { e.preventDefault(); open(); }
    });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); hi = (hi + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length; paint(); }
      else if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); hi = e.key === 'Home' ? 0 : opts.length - 1; paint(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(hi); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
      else if (e.key === 'Tab') close(false);
    });
    opts.forEach(function (o, k) {
      o.addEventListener('click', function () { pick(k); });
      o.addEventListener('mousemove', function () { if (hi !== k) { hi = k; paint(); } });
    });
    sel.addEventListener('change', sync);
    sync();
  }

  function boot(root, first) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-mdco-dd]'), initDropdown);
    Array.prototype.forEach.call(root.querySelectorAll('[data-mdco-msgs] form'), initForm);
    if (first) {
      var done = document.querySelector('[data-mdco-done]');
      if (done) { done.focus({ preventScroll: true }); if (done.scrollIntoView) done.scrollIntoView({ block: 'center' }); }
    }
  }
  window.MDCO_BOOT = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document, true); });
  else boot(document, true);

  if (!window.Shopify || !window.Shopify.designMode) return;
  document.addEventListener('shopify:section:load', function (e) {
    try { boot(e.target, false); } catch (err) { console.error('md-co set-up after an edit', err); }
  });
  function preview(el, on) {
    var form = el.closest('form');
    if (!form) return;
    el.hidden = !on;
    if (el.getAttribute('data-mdco-preview') === 'done') {
      Array.prototype.forEach.call(form.querySelectorAll('.mdco-fo__fields, .mdco-fo__foot, .mdco-fo__err'), function (x) {
        if (on) { x.__mdcoHid = x.hidden; x.hidden = true; } else if (x !== el) { x.hidden = x.hasAttribute('data-mdco-preview') ? true : !!x.__mdcoHid; }
      });
    }
  }
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.closest || !el.closest('[class^="mdco-"], [class*=" mdco-"]')) return;
    if (el.hasAttribute('data-mdco-preview')) { preview(el, true); }
    if (el.scrollIntoView) { try { el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) { el.scrollIntoView(); } }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var el = e.target;
    if (el && el.hasAttribute && el.hasAttribute('data-mdco-preview')) preview(el, false);
  });
})();
